// import React, { useState, useEffect } from 'react';
// import { useQuery, useMutation } from 'react-query';
// import { Box, Spinner, Table, Thead, Tbody, Tr, Th, Td, Button, Select, useToast } from '@chakra-ui/react';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import UserService from '../../services/UserService'; // Import your service

// const UsersList = () => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const toast = useToast();

//   const [limit, setLimit] = useState(10);
//   const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1);
//   const [filter, setFilter] = useState(searchParams.get('filter') || '');

//   useEffect(() => {
//     setSearchParams({ page, limit, filter });
//   }, [page, limit, filter, setSearchParams]);

//   const { data, isLoading, error, refetch } = useQuery(['users', { page, limit, filter }], () =>
//     UserService.fetchUsers(page, limit)
//   );
// console.log(data?.data?.data)
//   const blockMutation = useMutation(UserService.blockUser, {
//     onSuccess: () => {
//       toast({
//         title: "User status updated.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = Array.isArray(error.response.data.errors)
//         ? error.response.data.errors.map(err => err.msg).join(', ')
//         : error.response.data.message;

//       toast({
//         title: "Error updating user status.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const handleBlockUnblock = (userId, currentStatus) => {
//     blockMutation.mutate({ userId, status: !currentStatus });
//   };

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (error) {
//     return <Box>Error loading users.</Box>;
//   }

//   return (
//     <Box>
//       <Box mb={4}>
//         <Select value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter Users">
//           <option value="blocked">Blocked</option>
//           <option value="active">Active</option>
//           <option value="createdAt">Recently Created</option>
//         </Select>
//       </Box>
//       <Table>
//         <Thead>
//           <Tr>
//             <Th>Name</Th>
//             <Th>Email</Th>
//             <Th>Phone Number</Th>
//             <Th>Company Name</Th>
//             <Th>Created At</Th>
//             <Th>Actions</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {data?.data?.data?.map(user => (
//             <Tr key={user._id}>
//               <Td>{user.name}</Td>
//               <Td>{user.email}</Td>
//               <Td>{user.phoneNumber}</Td>
//               <Td>{user.companyname}</Td>
//               <Td>{new Date(user.createdAt).toLocaleDateString()}</Td>
//               <Td>
//                 <Button colorScheme={user.blocked ? "red" : "green"} onClick={() => handleBlockUnblock(user._id, user.blocked)}>
//                   {user.blocked ? 'Unblock' : 'Block'}
//                 </Button>
//                 <Button ml={2} onClick={() => navigate(`/users/${user._id}`)}>View Details</Button>
//               </Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>
//       <Box mt={4}>
//         <Button onClick={() => setPage(page => Math.max(page - 1, 1))} disabled={page === 1}>
//           Previous
//         </Button>
//         <Button onClick={() => setPage(page + 1)} disabled={data?.results < limit}>
//           Next
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default UsersList;


// import React, { useState, useEffect } from 'react';
// import { useQuery, useMutation } from 'react-query';
// import { Box, Spinner, Table, Thead, Tbody, Tr, Th, Td, Button, Select, useToast, Text } from '@chakra-ui/react';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import UserService from '../../services/UserService'; // Import your service

// const UsersList = () => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const toast = useToast();

//   const [limit, setLimit] = useState(5);
//   const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1);
//   const [filter, setFilter] = useState(searchParams.get('filter') || '');

//   useEffect(() => {
//     setSearchParams({ page, limit, filter });
//   }, [page, limit, filter, setSearchParams]);

//   const { data, isLoading, error, refetch } = useQuery(['users', { page, limit, filter }], () =>
//     UserService.fetchUsers({ page, limit, filter })
//   );
//   const blockMutation = useMutation(UserService.blockUser, {
//     onSuccess: () => {
//       toast({
//         title: "User status updated.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = Array.isArray(error.response.data.errors)
//         ? error.response.data.errors.map(err => err.msg).join(', ')
//         : error.response.data.message;

//       toast({
//         title: "Error updating user status.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const handleBlockUnblock = (userId, currentStatus) => {
//     blockMutation.mutate({ userId, status: !currentStatus });
//   };

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (error) {
//     return <Box>Error loading users.</Box>;
//   }

//   return (

//     <Box>
//         <Box>all users :{data?.counts}</Box>
//         <Box>results :{data?.results}</Box>

//       <Box mb={4}>
//         <Select value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter Users">
//           <option value="verified=true">Verified</option>
//           <option value="verified=false">Not Verified</option>
//           <option value="blocked=true">Blocked</option>
//           <option value="blocked=false">Active</option>
//         </Select>
//       </Box>
//       <Table>
//         <Thead>
//           <Tr>
//             <Th>Name</Th>
//             <Th>Email</Th>
//             <Th>Phone Number</Th>
//             <Th>Company Name</Th>
//             <Th>age</Th>
//             <Th>verified</Th>
//             <Th>blocked</Th>

//             <Th>Actions</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {data?.data?.data?.map(user => (
//             <Tr key={user._id}>
//               <Td>{user.name}</Td>
//               <Td>{user.email}</Td>
//               <Td>{user.phoneNumber}</Td>
//               <Td>{user.companyname}</Td>
//               <Td>{user.age}</Td>

//               {/* <Td>{new Date(user.createdAt).toLocaleDateString()}</Td> */}
//               <Td>
//                 <Text color={user.verified ? "green" : "red"}>
//                   {user.verified ? 'verified' : 'notverified'}
//                 </Text>
                
//               </Td>
//               <Td>
//                 <Text color={user.blocked ? "red" : "green"}>
//                   {user.blocked ? 'Blocked' : 'Active'}
//                 </Text>
                
//               </Td>
//               <Td>
//                 <Button colorScheme={user.blocked ? "red" : "green"} onClick={() => handleBlockUnblock(user._id, user.blocked)}>
//                   {user.blocked ? 'Unblock' : 'Block'}
//                 </Button>
//                 <Button ml={2} onClick={() => navigate(`/dashboard/admin/users/${user._id}`)}>View Details</Button>
//               </Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>
//       <Box mt={4}>
//         <Button onClick={() => setPage(page => Math.max(page - 1, 1))} disabled={page === 1}>
//           Previous
//         </Button>
//         <Button onClick={() => setPage(page + 1)} disabled={data?.results < limit}>
//           Next
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default UsersList;




















// import React, { useState, useEffect } from 'react';
// import { useQuery, useMutation } from 'react-query';
// import { Box, Spinner, Table, Thead, Tbody, Tr, Th, Td, Button, Select, useToast, Text } from '@chakra-ui/react';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import UserService from '../../services/UserService'; // Import your service

// const UsersList = () => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const toast = useToast();

//   const [limit, setLimit] = useState(5);
//   const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1);
//   const [filter, setFilter] = useState(searchParams.get('filter') || '');

//   useEffect(() => {
//     setSearchParams({ page, limit, filter });
//   }, [page, limit, filter, setSearchParams]);

//   const { data, isLoading, error, refetch } = useQuery(['users', { page, limit, filter }], () =>
//     UserService.fetchUsers({ page, limit, filter })
//   );

//   const blockMutation = useMutation(UserService.blockUser, {
//     onSuccess: () => {
//       toast({
//         title: "User status updated.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = Array.isArray(error.response.data.errors)
//         ? error.response.data.errors.map(err => err.msg).join(', ')
//         : error.response.data.message;

//       toast({
//         title: "Error updating user status.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const approveMutation = useMutation(UserService.approveUser, {
//     onSuccess: () => {
//       toast({
//         title: "User approved.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = Array.isArray(error.response.data.errors)
//         ? error.response.data.errors.map(err => err.msg).join(', ')
//         : error.response.data.message;

//       toast({
//         title: "Error approving user.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const handleBlockUnblock = (userId, currentStatus) => {
//     blockMutation.mutate({ userId, status: !currentStatus });
//   };

//   const handleApprove = (userId) => {
//     approveMutation.mutate(userId);
//   };

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (error) {
//     return <Box>Error loading users.</Box>;
//   }

//   return (
//     <Box>
//       <Box>All users: {data?.counts}</Box>
//       <Box>Results: {data?.results}</Box>

//       <Box mb={4}>
//         <Select value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter Users">
//           <option value="verified=true">Verified</option>
//           <option value="verified=false">Not Verified</option>
//           <option value="blocked=true">Blocked</option>
//           <option value="blocked=false">Active</option>
//           <option value="approved=true">Approved</option>
//           <option value="approved=false">Not Approved</option>
//         </Select>
//       </Box>
//       <Table>
//         <Thead>
//           <Tr>
//             <Th>Name</Th>
//             <Th>Email</Th>
//             <Th>Phone Number</Th>
//             <Th>Company Name</Th>
//             <Th>Age</Th>
//             <Th>Verified</Th>
//             <Th>Blocked</Th>
//             <Th>Approved</Th>
//             <Th>Actions</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {data?.data?.data?.map(user => (
//             <Tr key={user._id}>
//               <Td>{user.name}</Td>
//               <Td>{user.email}</Td>
//               <Td>{user.phoneNumber}</Td>
//               <Td>{user.companyname}</Td>
//               <Td>{user.age}</Td>
//               <Td>
//                 <Text color={user.verified ? "green" : "red"}>
//                   {user.verified ? 'Verified' : 'Not Verified'}
//                 </Text>
//               </Td>
//               <Td>
//                 <Text color={user.blocked ? "red" : "green"}>
//                   {user.blocked ? 'Blocked' : 'Active'}
//                 </Text>
//               </Td>
//               <Td>
//                 <Text color={user.approved ? "green" : "red"}>
//                   {user.approved ? 'Approved' : 'Not Approved'}
//                 </Text>
//               </Td>
//               <Td>
//                 <Button colorScheme={user.blocked ? "red" : "green"} onClick={() => handleBlockUnblock(user._id, user.blocked)}>
//                   {user.blocked ? 'Unblock' : 'Block'}
//                 </Button>
//                 {!user.approved && (
//                   <Button ml={2} colorScheme="blue" onClick={() => handleApprove(user._id)}>
//                     Approve
//                   </Button>
//                 )}
//                 <Button ml={2} onClick={() => navigate(`/dashboard/admin/users/${user._id}`)}>View Details</Button>
//               </Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>
//       <Box mt={4}>
//         <Button onClick={() => setPage(page => Math.max(page - 1, 1))} disabled={page === 1}>
//           Previous
//         </Button>
//         <Button onClick={() => setPage(page + 1)} disabled={data?.results < limit}>
//           Next
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default UsersList;














































///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////









// import React, { useState, useEffect, useRef } from 'react';
// import { useQuery, useMutation } from 'react-query';
// import { Box, Spinner, Table, Thead, Tbody, Tr, Th, Td, Button, Select, useToast, Text, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay } from '@chakra-ui/react';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import UserService from '../../services/UserService'; // Import your service

// const UsersList = () => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const toast = useToast();

//   const [limit, setLimit] = useState(5);
//   const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1);
//   const [filter, setFilter] = useState(searchParams.get('filter') || '');
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [isOpen, setIsOpen] = useState(false);
//   const cancelRef = useRef();

//   useEffect(() => {
//     setSearchParams({ page, limit, filter });
//   }, [page, limit, filter, setSearchParams]);

//   const { data, isLoading, error, refetch } = useQuery(['users', { page, limit, filter }], () =>
//     UserService.fetchUsers({ page, limit, filter })
//   );

//   const blockMutation = useMutation(UserService.blockUser, {
//     onSuccess: () => {
//       toast({
//         title: "User status updated.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = Array.isArray(error.response.data.errors)
//         ? error.response.data.errors.map(err => err.msg).join(', ')
//         : error.response.data.message;

//       toast({
//         title: "Error updating user status.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const approveMutation = useMutation(UserService.approveUser, {
//     onSuccess: () => {
//       toast({
//         title: "User approved.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = Array.isArray(error.response.data.errors)
//         ? error.response.data.errors.map(err => err.msg).join(', ')
//         : error.response.data.message;

//       toast({
//         title: "Error approving user.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const deleteUserMutation = useMutation(UserService.deleteUser, {
//     onSuccess: () => {
//       toast({
//         title: "User deleted.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = error.response?.data?.message || "Error deleting user.";
//       toast({
//         title: "Error deleting user.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const handleBlockUnblock = (userId, currentStatus) => {
//     blockMutation.mutate({ userId, status: !currentStatus });
//   };

//   const handleApprove = (userId) => {
//     approveMutation.mutate(userId);
//   };

//   const handleDeleteConfirmation = (userId) => {
//     setSelectedUserId(userId);
//     setIsOpen(true);
//   };

//   const handleDelete = () => {
//     deleteUserMutation.mutate(selectedUserId);
//     setIsOpen(false);
//     setSelectedUserId(null);
//   };

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (error) {
//     return <Box>Error loading users.</Box>;
//   }

//   return (
//     <Box>
//       <Box>All users: {data?.counts}</Box>
//       <Box>Results: {data?.results}</Box>

//       <Box mb={4}>
//         <Select value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter Users">
//           <option value="verified=true">Verified</option>
//           <option value="verified=false">Not Verified</option>
//           <option value="blocked=true">Blocked</option>
//           <option value="blocked=false">Active</option>
//           <option value="approved=true">Approved</option>
//           <option value="approved=false">Not Approved</option>
//         </Select>
//       </Box>
//       <Table>
//         <Thead>
//           <Tr>
//             <Th>Name</Th>
//             <Th>Email</Th>
//             <Th>Phone Number</Th>
//             <Th>Company Name</Th>
//             <Th>Age</Th>
//             <Th>Verified</Th>
//             <Th>Blocked</Th>
//             <Th>Approved</Th>
//             <Th>Actions</Th>
//           </Tr>
//         </Thead>
//         <Tbody>
//           {data?.data?.data?.map(user => (
//             <Tr key={user._id}>
//               <Td>{user.name}</Td>
//               <Td>{user.email}</Td>
//               <Td>{user.phoneNumber}</Td>
//               <Td>{user.companyname}</Td>
//               <Td>{user.age}</Td>
//               <Td>
//                 <Text color={user.verified ? "green" : "red"}>
//                   {user.verified ? 'Verified' : 'Not Verified'}
//                 </Text>
//               </Td>
//               <Td>
//                 <Text color={user.blocked ? "red" : "green"}>
//                   {user.blocked ? 'Blocked' : 'Active'}
//                 </Text>
//               </Td>
//               <Td>
//                 <Text color={user.approved ? "green" : "red"}>
//                   {user.approved ? 'Approved' : 'Not Approved'}
//                 </Text>
//               </Td>
//               <Td>
//                 <Button colorScheme={user.blocked ? "red" : "green"} onClick={() => handleBlockUnblock(user._id, user.blocked)}>
//                   {user.blocked ? 'Unblock' : 'Block'}
//                 </Button>
//                 {!user.approved && (
//                   <Button ml={2} colorScheme="blue" onClick={() => handleApprove(user._id)}>
//                     Approve
//                   </Button>
//                 )}
//                 <Button ml={2} onClick={() => navigate(`/dashboard/admin/users/${user._id}`)}>View Details</Button>
//                 <Button ml={2} colorScheme="red" onClick={() => handleDeleteConfirmation(user._id)}>Delete</Button>
//               </Td>
//             </Tr>
//           ))}
//         </Tbody>
//       </Table>
//       <Box mt={4}>
//         <Button onClick={() => setPage(page => Math.max(page - 1, 1))} disabled={page === 1}>
//           Previous
//         </Button>
//         <Button onClick={() => setPage(page + 1)} disabled={data?.results < limit}>
//           Next
//         </Button>
//       </Box>

//       <AlertDialog
//         isOpen={isOpen}
//         leastDestructiveRef={cancelRef}
//         onClose={() => setIsOpen(false)}
//       >
//         <AlertDialogOverlay>
//           <AlertDialogContent>
//             <AlertDialogHeader fontSize="lg" fontWeight="bold">
//               Delete User
//             </AlertDialogHeader>

//             <AlertDialogBody>
//               Are you sure? You can't undo this action. All related data (bids, deposits, file bookings, winners, subcategory results, wallet charges, and payments) will also be deleted.
//             </AlertDialogBody>

//             <AlertDialogFooter>
//               <Button ref={cancelRef} onClick={() => setIsOpen(false)}>
//                 Cancel
//               </Button>
//               <Button colorScheme="red" onClick={handleDelete} ml={3}>
//                 Delete
//               </Button>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialogOverlay>
//       </AlertDialog>
//     </Box>
//   );
// };

// export default UsersList;

















///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////





// import React, { useState, useEffect, useRef } from 'react';
// import { useQuery, useMutation } from 'react-query';
// import { Box, Spinner, Table, Thead, Tbody, Tr, Th, Td, Button, Select, useToast, Text, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay } from '@chakra-ui/react';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import UserService from '../../services/UserService'; // Import your service

// const UsersList = () => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const toast = useToast();

//   const [limit, setLimit] = useState(5);
//   const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1);
//   const [filter, setFilter] = useState(searchParams.get('filter') || '');
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [isOpen, setIsOpen] = useState(false);
//   const cancelRef = useRef();

//   useEffect(() => {
//     setSearchParams({ page, limit, filter });
//   }, [page, limit, filter, setSearchParams]);

//   const { data, isLoading, error, refetch } = useQuery(['users', { page, limit, filter }], () =>
//     UserService.fetchUsers({ page, limit, filter })
//   );
// console.log(data)
//   const blockMutation = useMutation(UserService.blockUser, {
//     onSuccess: () => {
//       toast({
//         title: "User status updated.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = Array.isArray(error.response.data.errors)
//         ? error.response.data.errors.map(err => err.msg).join(', ')
//         : error.response.data.message;

//       toast({
//         title: "Error updating user status.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const approveMutation = useMutation(UserService.approveUser, {
//     onSuccess: () => {
//       toast({
//         title: "User approved.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = Array.isArray(error.response.data.errors)
//         ? error.response.data.errors.map(err => err.msg).join(', ')
//         : error.response.data.message;

//       toast({
//         title: "Error approving user.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const deleteUserMutation = useMutation(UserService.deleteUser, {
//     onSuccess: () => {
//       toast({
//         title: "User deleted.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = error.response?.data?.message || "Error deleting user.";
//       toast({
//         title: "Error deleting user.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const handleBlockUnblock = (userId, currentStatus) => {
//     blockMutation.mutate({ userId, status: !currentStatus });
//   };

//   const handleApprove = (userId) => {
//     approveMutation.mutate(userId);
//   };

//   const handleDeleteConfirmation = (userId) => {
//     setSelectedUserId(userId);
//     setIsOpen(true);
//   };

//   const handleDelete = () => {
//     deleteUserMutation.mutate(selectedUserId);
//     setIsOpen(false);
//     setSelectedUserId(null);
//   };

//   if (isLoading) {
//     return <Spinner />;
//   }

//   if (error) {
//     return <Box>Error loading users.</Box>;
//   }

//   return (
//     <Box w={{ base: '100%', md: '100%', lg: '100%' }} mx="auto" p={{ base: 2, md: 4 }}>
//       <Box mb={4}>
//         <Text fontSize="lg">All users: {data?.counts}</Text>
//         <Text fontSize="lg">Results: {data?.results}</Text>
//       </Box>

//       <Box mb={4}>
//         <Select value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter Users">
//           <option value="verified=true">Verified</option>
//           <option value="verified=false">Not Verified</option>
//           <option value="blocked=true">Blocked</option>
//           <option value="blocked=false">Active</option>
//           <option value="approved=true">Approved</option>
//           <option value="approved=false">Not Approved</option>
//         </Select>
//       </Box>

//       <Box overflowX="auto">
//         <Table variant="simple" size="sm">
//           <Thead>
//             <Tr>
//               <Th>Name</Th>
//               <Th>Email</Th>
//               <Th>Phone Number</Th>
//               <Th>Company Name</Th>
//               <Th>Age</Th>
//               <Th>Verified</Th>
//               <Th>Blocked</Th>
//               <Th>Approved</Th>
//               <Th>Actions</Th>
//             </Tr>
//           </Thead>
//           <Tbody>
//             {data?.data?.data?.map(user => (
//               <Tr key={user._id}>
//                 <Td>{user.name}</Td>
//                 <Td>{user.email}</Td>
//                 <Td>{user.phoneNumber}</Td>
//                 <Td>{user.companyname}</Td>
//                 <Td>{user.age}</Td>
//                 <Td>
//                   <Text color={user.verified ? "green" : "red"}>
//                     {user.verified ? 'Verified' : 'Not Verified'}
//                   </Text>
//                 </Td>
//                 <Td>
//                   <Text color={user.blocked ? "red" : "green"}>
//                     {user.blocked ? 'Blocked' : 'Active'}
//                   </Text>
//                 </Td>
//                 <Td>
//                   <Text color={user.approved ? "green" : "red"}>
//                     {user.approved ? 'Approved' : 'Not Approved'}
//                   </Text>
//                 </Td>
//                 <Td>
//                   <Button colorScheme={user.blocked ? "red" : "green"} onClick={() => handleBlockUnblock(user._id, user.blocked)}>
//                     {user.blocked ? 'Unblock' : 'Block'}
//                   </Button>
//                   {!user.approved && (
//                     <Button ml={2} colorScheme="blue" onClick={() => handleApprove(user._id)}>
//                       Approve
//                     </Button>
//                   )}
//                   <Button ml={2} onClick={() => navigate(`/dashboard/admin/users/${user._id}`)}>View Details</Button>
//                   <Button ml={2} colorScheme="red" onClick={() => handleDeleteConfirmation(user._id)}>Delete</Button>
//                 </Td>
//               </Tr>
//             ))}
//           </Tbody>
//         </Table>
//       </Box>

//       <Box mt={4} display="flex" justifyContent="space-between">
//         <Button onClick={() => setPage(page => Math.max(page - 1, 1))} disabled={page === 1}>
//           Previous
//         </Button>
//         <Button onClick={() => setPage(page + 1)} disabled={data?.results < limit}>
//           Next
//         </Button>
//       </Box>

//       <AlertDialog
//         isOpen={isOpen}
//         leastDestructiveRef={cancelRef}
//         onClose={() => setIsOpen(false)}
//       >
//         <AlertDialogOverlay>
//           <AlertDialogContent>
//             <AlertDialogHeader fontSize="lg" fontWeight="bold">
//               Delete User
//             </AlertDialogHeader>

//             <AlertDialogBody>
//               Are you sure? You can't undo this action. All related data (bids, deposits, file bookings, winners, subcategory results, wallet charges, and payments) will also be deleted.
//             </AlertDialogBody>

//             <AlertDialogFooter>
//               <Button ref={cancelRef} onClick={() => setIsOpen(false)}>
//                 Cancel
//               </Button>
//               <Button colorScheme="red" onClick={handleDelete} ml={3}>
//                 Delete
//               </Button>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialogOverlay>
//       </AlertDialog>
//     </Box>
//   );
// };

// export default UsersList;









// import React, { useState, useEffect, useRef } from 'react';
// import { useQuery, useMutation } from 'react-query';
// import {
//   Box, Spinner, Table, Thead, Tbody, Tr, Th, Td, Button, Select, useToast,
//   Text, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, 
//   AlertDialogContent, AlertDialogOverlay
// } from '@chakra-ui/react';
// import { useSearchParams, useNavigate } from 'react-router-dom';
// import UserService from '../../services/UserService'; // Import your service
// import CustomSpinner from './../EndedAuctions/CustomSpinner';

// const UsersList = () => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const navigate = useNavigate();
//   const toast = useToast();

//   const [limit, setLimit] = useState(5);
//   const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1);
//   const [filter, setFilter] = useState(searchParams.get('filter') || '');
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [isVerifyOpen, setIsVerifyOpen] = useState(false);
//   const [isDeleteOpen, setIsDeleteOpen] = useState(false);
//   const cancelRef = useRef();

//   useEffect(() => {
//     setSearchParams({ page, limit, filter });
//   }, [page, limit, filter, setSearchParams]);

//   const { data, isLoading, error, refetch } = useQuery(['users', { page, limit, filter }], () =>
//     UserService.fetchUsers({ page, limit, filter })
//   );

//   const blockMutation = useMutation(UserService.blockUser, {
//     onSuccess: () => {
//       toast({
//         title: "User status updated.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = Array.isArray(error.response.data.errors)
//         ? error.response.data.errors.map(err => err.msg).join(', ')
//         : error.response.data.message;

//       toast({
//         title: "Error updating user status.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const approveMutation = useMutation(UserService.approveUser, {
//     onSuccess: () => {
//       toast({
//         title: "User approved.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = Array.isArray(error.response.data.errors)
//         ? error.response.data.errors.map(err => err.msg).join(', ')
//         : error.response.data.message;

//       toast({
//         title: "Error approving user.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const verifyUserMutation = useMutation(UserService.verifyUser, {
//     onSuccess: () => {
//       toast({
//         title: "User verified successfully.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = error.response?.data?.message || "Error verifying user.";
//       toast({
//         title: "Error verifying user.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const deleteUserMutation = useMutation(UserService.deleteUser, {
//     onSuccess: () => {
//       toast({
//         title: "User deleted.",
//         status: "success",
//         duration: 5000,
//         isClosable: true,
//       });
//       refetch();
//     },
//     onError: (error) => {
//       const errorMessage = error.response?.data?.message || "Error deleting user.";
//       toast({
//         title: "Error deleting user.",
//         description: errorMessage,
//         status: "error",
//         duration: 5000,
//         isClosable: true,
//       });
//     }
//   });

//   const handleBlockUnblock = (userId, currentStatus) => {
//     blockMutation.mutate({ userId, status: !currentStatus });
//   };

//   const handleApprove = (userId) => {
//     approveMutation.mutate(userId);
//   };

//   const handleVerifyConfirmation = (userId) => {
//     setSelectedUserId(userId);
//     setIsVerifyOpen(true);
//   };

//   const handleVerify = () => {
//     verifyUserMutation.mutate(selectedUserId);
//     setIsVerifyOpen(false);
//     setSelectedUserId(null);
//   };

//   const handleDeleteConfirmation = (userId) => {
//     setSelectedUserId(userId);
//     setIsDeleteOpen(true);
//   };

//   const handleDelete = () => {
//     deleteUserMutation.mutate(selectedUserId);
//     setIsDeleteOpen(false);
//     setSelectedUserId(null);
//   };

//   if (isLoading) {
//     return <CustomSpinner />;
//   }

//   if (error) {
//     return <Box>Error loading users.</Box>;
//   }

//   return (
//     <Box w={{ base: '100%', md: '100%', lg: '100%' }} mx="auto" p={{ base: 2, md: 4 }}>
//       <Box mb={4}>
//         <Text fontSize="lg">All users: {data?.counts}</Text>
//         <Text fontSize="lg">Results: {data?.results}</Text>
//       </Box>

//       <Box mb={4}>
//         <Select value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter Users">
//           <option value="verified=true">Verified</option>
//           <option value="verified=false">Not Verified</option>
//           <option value="blocked=true">Blocked</option>
//           <option value="blocked=false">Active</option>
//           <option value="approved=true">Approved</option>
//           <option value="approved=false">Not Approved</option>
//         </Select>
//       </Box>

//       <Box overflowX="auto">
//         <Table variant="simple" size="sm">
//           <Thead>
//             <Tr>
//               <Th>Name</Th>
//               <Th>Email</Th>
//               <Th>Phone Number</Th>
//               <Th>Company Name</Th>
//               <Th>Age</Th>
//               <Th>Verified</Th>
//               <Th>Blocked</Th>
//               <Th>Approved</Th>
//               <Th>Actions</Th>
//             </Tr>
//           </Thead>
//           <Tbody>
//             {data?.data?.data?.map(user => (
//               <Tr key={user._id}>
//                 <Td>{user.name}</Td>
//                 <Td>{user.email}</Td>
//                 <Td>{user.phoneNumber}</Td>
//                 <Td>{user.companyname}</Td>
//                 <Td>{user.age}</Td>
//                 <Td>
//                   <Text color={user.verified ? "green" : "red"}>
//                     {user.verified ? 'Verified' : 'Not Verified'}
//                   </Text>
//                 </Td>
//                 <Td>
//                   <Text color={user.blocked ? "red" : "green"}>
//                     {user.blocked ? 'Blocked' : 'Active'}
//                   </Text>
//                 </Td>
//                 <Td>
//                   <Text color={user.approved ? "green" : "red"}>
//                     {user.approved ? 'Approved' : 'Not Approved'}
//                   </Text>
//                 </Td>
//                 <Td>
//                   <Button colorScheme={user.blocked ? "red" : "green"} onClick={() => handleBlockUnblock(user._id, user.blocked)}>
//                     {user.blocked ? 'Unblock' : 'Block'}
//                   </Button>
//                   {!user.approved && (
//                     <Button ml={2} colorScheme="blue" onClick={() => handleApprove(user._id)}>
//                       Approve
//                     </Button>
//                   )}
//                   {!user.verified && (
//                     <Button ml={2} colorScheme="orange" onClick={() => handleVerifyConfirmation(user._id)}>
//                       Verify
//                     </Button>
//                   )}
//                   <Button ml={2} onClick={() => navigate(`/dashboard/admin/users/${user._id}`)}>View Details</Button>
//                   <Button ml={2} colorScheme="red" onClick={() => handleDeleteConfirmation(user._id)}>Delete</Button>
//                 </Td>
//               </Tr>
//             ))}
//           </Tbody>
//         </Table>
//       </Box>

//       <Box mt={4} display="flex" justifyContent="space-between">
//         <Button onClick={() => setPage(page => Math.max(page - 1, 1))} disabled={page === 1}>
//           Previous
//         </Button>
//         <Button onClick={() => setPage(page + 1)} disabled={data?.results < limit}>
//           Next
//         </Button>
//       </Box>

//       <AlertDialog
//         isOpen={isVerifyOpen}
//         leastDestructiveRef={cancelRef}
//         onClose={() => setIsVerifyOpen(false)}
//       >
//         <AlertDialogOverlay>
//           <AlertDialogContent>
//             <AlertDialogHeader fontSize="lg" fontWeight="bold">
//               Verify User
//             </AlertDialogHeader>

//             <AlertDialogBody>
//               Are you sure you want to verify this user?
//             </AlertDialogBody>

//             <AlertDialogFooter>
//               <Button ref={cancelRef} onClick={() => setIsVerifyOpen(false)}>
//                 Cancel
//               </Button>
//               <Button colorScheme="orange" onClick={handleVerify} ml={3}>
//                 Verify
//               </Button>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialogOverlay>
//       </AlertDialog>

//       <AlertDialog
//         isOpen={isDeleteOpen}
//         leastDestructiveRef={cancelRef}
//         onClose={() => setIsDeleteOpen(false)}
//       >
//         <AlertDialogOverlay>
//           <AlertDialogContent>
//             <AlertDialogHeader fontSize="lg" fontWeight="bold">
//               Delete User
//             </AlertDialogHeader>

//             <AlertDialogBody>
//               Are you sure? You can't undo this action. All related data (bids, deposits, file bookings, winners, subcategory results, wallet charges, and payments) will also be deleted.
//             </AlertDialogBody>

//             <AlertDialogFooter>
//               <Button ref={cancelRef} onClick={() => setIsDeleteOpen(false)}>
//                 Cancel
//               </Button>
//               <Button colorScheme="red" onClick={handleDelete} ml={3}>
//                 Delete
//               </Button>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialogOverlay>
//       </AlertDialog>
//     </Box>
//   );
// };

// export default UsersList;














import React, { useState, useEffect, useRef } from 'react';
import { useQuery, useMutation } from 'react-query';
import {
  Box, Spinner, Table, Thead, Tbody, Tr, Th, Td, Button, Select, Input, useToast,
  Text, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, 
  AlertDialogContent, AlertDialogOverlay,
  Flex
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import UserService from '../../services/UserService'; // Import your service
import CustomSpinner from './../EndedAuctions/CustomSpinner';

const UsersList = () => {
  const navigate = useNavigate();
  const toast = useToast();

  const [limit, setLimit] = useState(50);  // Number of items per page
  const [page, setPage] = useState(1);  // Current page
  const [filter, setFilter] = useState('');  // User status filter
  const [phoneNumber, setPhoneNumber] = useState('');  // Search input for phone number
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isVerifyOpen, setIsVerifyOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const cancelRef = useRef();

  // Fetch users (without phone number filtering in the query)
  const { data, isLoading, error, refetch } = useQuery(['users', { page, limit, filter }], () =>
    UserService.fetchUsers({ page, limit, filter })
  );

  // Mutations for user actions (block, approve, verify, delete)
  const blockMutation = useMutation(UserService.blockUser, {
    onSuccess: () => {
      toast({ title: "User status updated.", status: "success", duration: 5000, isClosable: true });
      refetch();
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || "Error updating user status.";
      toast({ title: "Error", description: errorMessage, status: "error", duration: 5000, isClosable: true });
    }
  });

  const approveMutation = useMutation(UserService.approveUser, {
    onSuccess: () => {
      toast({ title: "User approved.", status: "success", duration: 5000, isClosable: true });
      refetch();
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || "Error approving user.";
      toast({ title: "Error", description: errorMessage, status: "error", duration: 5000, isClosable: true });
    }
  });

  const verifyUserMutation = useMutation(UserService.verifyUser, {
    onSuccess: () => {
      toast({ title: "User verified successfully.", status: "success", duration: 5000, isClosable: true });
      refetch();
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || "Error verifying user.";
      toast({ title: "Error", description: errorMessage, status: "error", duration: 5000, isClosable: true });
    }
  });

  const deleteUserMutation = useMutation(UserService.deleteUser, {
    onSuccess: () => {
      toast({ title: "User deleted.", status: "success", duration: 5000, isClosable: true });
      refetch();
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || "Error deleting user.";
      toast({ title: "Error", description: errorMessage, status: "error", duration: 5000, isClosable: true });
    }
  });

  // Handlers for blocking, approving, verifying, and deleting users
  const handleBlockUnblock = (userId, currentStatus) => {
    blockMutation.mutate({ userId, status: !currentStatus });
  };

  const handleApprove = (userId) => {
    approveMutation.mutate(userId);
  };

  const handleVerifyConfirmation = (userId) => {
    setSelectedUserId(userId);
    setIsVerifyOpen(true);
  };

  const handleVerify = () => {
    verifyUserMutation.mutate(selectedUserId);
    setIsVerifyOpen(false);
    setSelectedUserId(null);
  };

  const handleDeleteConfirmation = (userId) => {
    setSelectedUserId(userId);
    setIsDeleteOpen(true);
  };

  const handleDelete = () => {
    deleteUserMutation.mutate(selectedUserId);
    setIsDeleteOpen(false);
    setSelectedUserId(null);
  };

  // Filter users by phone number locally (after data is fetched)
  const filteredUsers = phoneNumber
    ? data?.data?.data?.filter(user => user.phoneNumber.includes(phoneNumber))
    : data?.data?.data;

  // Pagination control
  const handleNextPage = () => setPage(page => page + 1);
  const handlePreviousPage = () => setPage(page => Math.max(page - 1, 1));

  if (isLoading) {
    return <CustomSpinner />;
  }

  if (error) {
    return <Box>Error loading users.</Box>;
  }

  return (
    <Box w={{ base: '100%', md: '100%', lg: '100%' }} mx="auto" p={{ base: 2, md: 4 }}>
      <Box mb={4}>
        <Text fontSize="lg">All users: {data?.counts}</Text>
        <Text fontSize="lg">Results: {data?.results}</Text>
      </Box>

      {/* Search and Filter Inputs */}
      <Box mb={4} display="flex" justifyContent="space-between">
        <Select value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Filter Users" width="200px">
          <option value="verified=true">Verified</option>
          <option value="verified=false">Not Verified</option>
          <option value="blocked=true">Blocked</option>
          <option value="blocked=false">Active</option>
          <option value="approved=true">Approved</option>
          <option value="approved=false">Not Approved</option>
        </Select>
        <Input
          placeholder="Search by phone number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}  // Update phone number state
          width="300px"
        />
      </Box>

      {/* User Table */}
      <Box  overflowX="auto">
        <Table variant="simple" size="sm">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Email</Th>
              <Th>Phone Number</Th>
              <Th>Another Phone</Th>
              <Th>Company Name</Th>
              <Th>Age</Th>
              <Th>Verified</Th>
              <Th>Blocked</Th>
              <Th>Approved</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredUsers?.map(user => (
              <Tr key={user._id}>
                <Td>{user.name}</Td>
                <Td>{user.email}</Td>
                <Td>{user.phoneNumber}</Td>
                <Td>{user?.altphoneNumber}</Td>

                <Td>{user.companyname}</Td>
                <Td>{user.age}</Td>
                <Td>
                  <Text color={user.verified ? "green" : "red"}>
                    {user.verified ? 'Verified' : 'Not Verified'}
                  </Text>
                </Td>
                <Td>
                  <Text color={user.blocked ? "red" : "green"}>
                    {user.blocked ? 'Blocked' : 'Active'}
                  </Text>
                </Td>
                <Td>
                  <Text color={user.approved ? "green" : "red"}>
                    {user.approved ? 'Approved' : 'Not Approved'}
                  </Text>
                </Td>
                <Td>
            <Flex  justifyContent="space-between">
            <Button
                width={{ base: "100%", md: "auto" }}
                ml={{ base: 0, md: 2 }}
                onClick={() => navigate(`/dashboard/admin/users/${user._id}`)}
                mb={2}
              >
                View Details
              </Button>
              <Button
                width={{ base: "100%", md: "auto" }}
                colorScheme={user.blocked ? "red" : "green"}
                onClick={() => handleBlockUnblock(user._id, user.blocked)}
                mb={2} // Add margin for spacing on small screens
              >
                {user.blocked ? 'Unblock' : 'Block'}
              </Button>

              {!user.approved && (
                <Button
                  width={{ base: "100%", md: "auto" }}
                  ml={{ base: 0, md: 2 }}
                  colorScheme="blue"
                  onClick={() => handleApprove(user._id)}
                  mb={2}
                >
                  Approve
                </Button>
              )}

              {!user.verified && (
                <Button
                  width={{ base: "100%", md: "auto" }}
                  ml={{ base: 0, md: 2 }}
                  colorScheme="orange"
                  onClick={() => handleVerifyConfirmation(user._id)}
                  mb={2}
                >
                  Verify
                </Button>
              )}

    

              <Button
                width={{ base: "100%", md: "auto" }}
                ml={{ base: 0, md: 2 }}
                colorScheme="red"
                onClick={() => handleDeleteConfirmation(user._id)}
              >
                Delete
              </Button>
            </Flex>
          </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      {/* Pagination Controls */}
      <Box mt={4} display="flex" justifyContent="space-between">
        <Button onClick={handlePreviousPage} disabled={page === 1}>
          Previous
        </Button>
        <Button onClick={handleNextPage} disabled={data?.results < limit}>
          Next
        </Button>
      </Box>

      {/* Verify Dialog */}
      <AlertDialog isOpen={isVerifyOpen} leastDestructiveRef={cancelRef} onClose={() => setIsVerifyOpen(false)}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Verify User
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure you want to verify this user?
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={() => setIsVerifyOpen(false)}>
                Cancel
              </Button>
              <Button colorScheme="orange" onClick={handleVerify} ml={3}>
                Verify
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Delete Dialog */}
      <AlertDialog isOpen={isDeleteOpen} leastDestructiveRef={cancelRef} onClose={() => setIsDeleteOpen(false)}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete User
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure? You can't undo this action. All related data will also be deleted.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={() => setIsDeleteOpen(false)}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default UsersList;

